'use client';

import Image from 'next/image';
import { useState } from 'react';

import { staticMediaStoreBaseURL } from '@/config/common';
import { useIsMobile } from '@/lib/screenResolution';

const handleOnChange = ({
  setIsSearchDropdownOpen,
  setSearchableAttribute,
  value
}) => {
  setSearchableAttribute(value);
  setIsSearchDropdownOpen(false);
};

const SearchDropDownOptions = ({
  searchableAttribute,
  searchAttributeLabelList,
  setIsSearchDropdownOpen,
  setSearchableAttribute
}) => (
  <div className='w-44 border shadow-sm border-platinum bg-white absolute !left-0 z-2 mt-11 md:mt-14 p-4 search-filter-modal'>
    <ul className='flex flex-col gap-4'>
      {searchAttributeLabelList.map(({ esDocKey, key, label }, id) => (
        <li
          key={`${key}_${id}`}
          className='relative block searchkit-filter-menu-item cursor-pointer'
        >
          <label className='cursor-pointer'>
            <input
              {...{
                checked: searchableAttribute === esDocKey,
                className:
                  'checked:content-searchkit-filter-menu-item-checked searchkit-filter-menu-item-checked searchkit-radio',
                name: 'searchable attribute option',
                onChange: () =>
                  handleOnChange({
                    setIsSearchDropdownOpen,
                    setSearchableAttribute,
                    value: esDocKey
                  }),
                type: 'radio',
                value: key
              }}
            />
            <span className='before:bg-searchkit-filter-menu-item empty-radio-span inline-block w-5 h-5'></span>
            <span className='text-sm text-dim-gray font-medium pl-2 self-center'>
              {label}
            </span>
          </label>
        </li>
      ))}
    </ul>
  </div>
);

const ScopeSearchAttributeModalMobile = ({
  searchableAttribute,
  searchAttributeLabelList,
  setSearchableAttribute
}) => {
  const [isSearchDropdownOpen, setIsSearchDropdownOpen] = useState(false);

  const [isMobile] = useIsMobile();
  return (
    <div className='search-filter-icon flex mx-2 cursor-pointer'>
      <div
        className={`${
          searchableAttribute
            ? 'border border-brand rounded-full p-1 absolute left-1 top-1'
            : 'absolute left-2 top-2'
        }`}
      >
        <Image
          alt={
            searchableAttribute
              ? 'select attribute icon red'
              : 'attribute icon gray'
          }
          className=''
          onClick={() => setIsSearchDropdownOpen(!isSearchDropdownOpen)}
          height={isMobile ? 20 : 30}
          src={`${staticMediaStoreBaseURL}/icons/${
            searchableAttribute
              ? 'select-attribute-icon-red'
              : 'attribute-icon-gray'
          }.svg`}
          width={isMobile ? 20 : 30}
        />
      </div>
      {isSearchDropdownOpen && (
        <SearchDropDownOptions
          {...{
            searchableAttribute,
            searchAttributeLabelList,
            setIsSearchDropdownOpen,
            setSearchableAttribute
          }}
        />
      )}
    </div>
  );
};

export default ScopeSearchAttributeModalMobile;
